import { useQuery } from "react-query";
import { getOfficeAccounts } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

export const useGetOfficeAccounts = () => {
  return useQuery("GetOfficeAccounts", getOfficeAccounts, {
    refetchOnWindowFocus: false,
  });
};
